import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_CATEGORY_REQUEST = 'Material/GET_CATEGORY_REQUEST'
const GET_CATEGORY_SUCCESS = 'Material/GET_CATEGORY_SUCCESS'
const GET_CATEGORY_FAILURE = 'Material/GET_CATEGORY_FAILURE'

const UPDATE_CATEGORY_REQUEST = 'Material/UPDATE_CATEGORY_REQUEST'
const UPDATE_CATEGORY_SUCCESS = 'Material/UPDATE_CATEGORY_SUCCESS'
const UPDATE_CATEGORY_FAILURE = 'Material/UPDATE_CATEGORY_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  categories: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: action.payload
      }
    case GET_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

// Action Creators
export const fetchCategories = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_CATEGORY_REQUEST
      })

      const response = await API.get(EndPoints.CATEGORY + `/all`)
      dispatch({
        type: GET_CATEGORY_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_CATEGORY_FAILURE
      })
    }
  }
}

export const updateCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CATEGORY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.CATEGORY + `/updateCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_CATEGORY_FAILURE
      })
    }
  }
}





